module.exports = __webpack_public_path__ + "static/azaad-brar-4d2e2a4c2a68e25c7a6ebb40f3583943.jpg";